export const Languages = {
  en: "EN",
  vi: "VI",
};
